import React, { Fragment, Component } from 'react';
export function Arsenal() {
  const triad = [{
    num: '01',
    icon: '🎨',
    tag: 'Diseño de Autoridad',
    name: 'DISEÑO\nDE ÉLITE',
    desc: 'Interfaces UI/UX de nivel Apple, Stripe y Airbnb generadas en segundos. La estética es la primera moneda de confianza en el mercado global.',
    features: ['Componentes UI de nivel enterprise al instante', 'Prototipado que justifica tickets de $2,000+', 'Integración directa con el flujo estratégico', 'Diseños que convierten visitantes en clientes'],
    featured: false
  }, {
    num: '02',
    icon: '⚡',
    tag: 'Ingeniería Sintética',
    name: 'CONSTRUCTOR\nDE SOFTWARE',
    desc: 'Construye aplicaciones web funcionales, plataformas SaaS y herramientas empresariales solo describiendo lo que necesitas.',
    features: ['Web-Apps funcionales con lenguaje natural', 'Micro-SaaS con ingresos recurrentes mensuales', 'Dashboards y herramientas internas para empresas', 'Deploy instantáneo, sin servidores que configurar'],
    featured: true
  }, {
    num: '03',
    icon: '🧠',
    tag: 'Inteligencia Estratégica',
    name: 'CEREBRO\nESTRATÉGICO',
    desc: 'Orquesta la estrategia de negocio y el copy de ventas. Refina y escala la lógica de tus aplicaciones al nivel enterprise.',
    features: ['Estrategia de negocios y arquitectura de proyectos', 'Copy de ventas que cierra contratos high-ticket', 'Refinamiento de código a nivel enterprise', 'Prompts que multiplican tu velocidad x100'],
    featured: false
  }];
  const flow = [{
    icon: '🧠',
    label: 'Diseña'
  }, {
    icon: '🎨',
    label: 'Estiliza'
  }, {
    icon: '⚡',
    label: 'Construye'
  }, {
    icon: '💻',
    label: 'Escala'
  }, {
    icon: '💰',
    label: 'Cobras'
  }];
  return <section className="py-8 md:py-[120px] px-4 md:px-12 relative z-10" aria-label="El Arsenal de Herramientas" data-id="element-26">
      <div className="max-w-[1100px] mx-auto" data-id="element-27">
        <div className="text-center mb-8 md:mb-20" data-id="element-28">
          <span className="section-tag" data-id="element-29">El Arsenal</span>
          <h2 className="font-display text-[clamp(2.5rem,6vw,6rem)] tracking-[3px] leading-none mb-4 md:mb-6" data-id="element-30">
            TU
            <br data-id="element-31" />
            <span className="text-gold drop-shadow-[0_0_20px_rgba(255,215,0,0.3)]" data-id="element-32">
              EXOESQUELETO
            </span>
            <br data-id="element-33" />
            DIGITAL
          </h2>
          <p className="font-text text-[0.88rem] md:text-[1.05rem] text-text-silver max-w-[600px] mx-auto leading-[1.6]" data-id="element-34">
            Tres pilares que te hacen 100 veces más productivo que un equipo de
            10 programadores senior. Sin código. Sin agencias. Sin límites.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-6 mb-8 md:mb-16" data-id="element-35">
          {triad.map((card, idx) => <div key={idx} className={`bg-bg-card border rounded-xl p-5 md:p-10 transition-all duration-[350ms] relative overflow-hidden flex flex-col gap-3 md:gap-4 group hover:bg-bg-card-hover hover:-translate-y-2 hover:shadow-[0_40px_80px_rgba(255,215,0,0.08)] ${card.featured ? 'border-border-glow bg-gradient-to-br from-gold-soft to-transparent' : 'border-border hover:border-border-glow'}`} data-id="element-36">
              <div className={`absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold to-transparent transition-opacity duration-300 ${card.featured ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'}`} aria-hidden="true" data-id="element-37" />
              <span className="absolute top-3 right-4 md:top-5 md:right-6 font-display text-[3rem] md:text-[4rem] text-gold/[0.06] leading-none tracking-[2px]" aria-hidden="true" data-id="element-38">
                {card.num}
              </span>
              <div className="w-10 h-10 md:w-[52px] md:h-[52px] border border-border-glow rounded-xl flex items-center justify-center text-[1.2rem] md:text-[1.5rem] bg-gold-soft" aria-hidden="true" data-id="element-39">
                {card.icon}
              </div>
              <span className="text-[0.6rem] md:text-[0.65rem] font-bold tracking-[3px] uppercase text-gold" data-id="element-40">
                {card.tag}
              </span>
              <h3 className="font-display text-[1.3rem] md:text-[1.6rem] tracking-[2px] text-white leading-[1.2] whitespace-pre-line" data-id="element-41">
                {card.name}
              </h3>
              <p className="text-[0.8rem] md:text-[0.9rem] text-text-silver leading-[1.6] flex-1" data-id="element-42">
                {card.desc}
              </p>
              <ul className="flex flex-col gap-1.5 md:gap-2" data-id="element-43">
                {card.features.map((f, fi) => <li key={fi} className="flex items-center gap-2 text-[0.72rem] md:text-[0.82rem] text-text-muted" data-id="element-44">
                    <span className="text-gold text-[0.65rem] shrink-0" aria-hidden="true" data-id="element-45">
                      ▸
                    </span>
                    {f}
                  </li>)}
              </ul>
            </div>)}
        </div>

        {/* Flow Diagram */}
        <div className="bg-bg-card border border-border rounded-xl p-4 md:p-10 flex flex-row items-center justify-center gap-2 md:gap-4 flex-wrap" aria-label="Flujo del Sistema Proxy" data-id="element-46">
          {flow.map((step, idx) => <Fragment key={idx} data-id="element-47">
              <div className="flex flex-col items-center gap-1 md:gap-2 text-center" data-id="element-48">
                <div className="w-9 h-9 md:w-12 md:h-12 rounded-full bg-gold-soft border border-border-glow flex items-center justify-center text-[1rem] md:text-[1.2rem]" aria-hidden="true" data-id="element-49">
                  {step.icon}
                </div>
                <span className="text-[0.55rem] md:text-[0.7rem] tracking-[1px] text-text-muted uppercase" data-id="element-50">
                  {step.label}
                </span>
              </div>
              {idx < flow.length - 1 && <span className="text-gold/50 text-[0.8rem] md:text-[1rem]" aria-hidden="true" data-id="element-51">
                  →
                </span>}
            </Fragment>)}
        </div>
      </div>
    </section>;
}